import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Slider from 'react-slick';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Text, Image, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import { Modal } from 'react-bootstrap';
import './Tips.scss';
import YouTubeGetID from '../Reusable/YouTubeGetID';

const Tips = (props) => {
  const { fields } = props;

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          centerMode: false,
          infinite: false,
          arrows: false,
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 681,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          centerMode: false,
          infinite: false,
          centerPadding: '50px',
          arrows: false,
        },
      },
    ],
  };
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  const modalClose = () => setShow(false);
  const modalShow = (url) => {
    const videoID = YouTubeGetID(url); // Extract the video ID from the URL
    const embedUrl = `https://www.youtube.com/embed/${videoID}`; // Fallback URL
    setVideoUrl(embedUrl); // Set the generated embed URL
    setShow(true);
  };

  // Render tabs dynamically
  const renderTabs = () =>
    fields.Tabs &&
    fields.Tabs.map((tab, index) => (
      <Tab eventKey={index.toString()} title={<Text field={tab.fields.heading} />} key={index}>
        <Slider {...sliderSettings}>
          {tab.fields.Cards &&
            tab.fields.Cards.map((cards, itemIndex) => (
              <div
                className="m-rl-15"
                key={itemIndex}
                onClick={() => modalShow(cards?.fields?.VideoUrl.value)}
              >
                {cards.fields.VideoImage && (
                  <>
                    <Image field={cards.fields.VideoImage} />
                    <a
                      className="play-btn"
                      onClick={() => modalShow(cards?.fields?.VideoUrl.value)}
                    >
                      <Image field={cards?.fields?.VideoIcon} />
                    </a>
                    <div className="help-content">
                      <Text field={cards.fields.VideoTitle} tag="h4" />
                      <RichText field={cards.fields.VideoText} tag="p" />
                    </div>
                  </>
                )}
              </div>
            ))}
        </Slider>
      </Tab>
    ));

  return (
    <>
      <div className="wrapperCol caretips">
        <Text field={fields.heading} tag="h2" />
        <Tabs
          defaultActiveKey={fields.Tabs && fields.Tabs.length > 0 ? '0' : null}
          id="uncontrolled-tab-example"
        >
          {renderTabs()}
        </Tabs>
      </div>
      <div className="modal-wrapper">
        <Modal show={show} onHide={modalClose} className="testimonial-video-wrapper">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="ratio ratio-16x9">
              <iframe
                src={`${videoUrl}?autoplay=1&rel=0&showinfo=0`}
                title="YouTube video"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default withSitecoreContext()(Tips);
